import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../lib/motion";

const CHAPTERS = [
  {
    n: "01",
    title: "We operate at the intersection.",
    body: "Where enterprise strategy meets physical infrastructure, and where artificial intelligence meets operational reality. Nexis exists in the space most firms cannot reach.",
  },
  {
    n: "02",
    title: "We build systems, not slideshows.",
    body: "From hyperscale data centers to autonomous AI platforms and billion-dollar construction programs — we deliver transformation that stands, scales, and endures.",
  },
  {
    n: "03",
    title: "We move at the speed of ambition.",
    body: "A boutique team of senior operators. No layers, no dilution. Direct access to the leaders who have delivered the most complex programs on earth.",
  },
];

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["12%", "-12%"]);

  return (
    <section
      ref={ref}
      className="relative border-t border-white/5 bg-nexis-bg/70 py-28 backdrop-blur-sm md:py-40"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] text-nexis-blue">— THE NEXIS DOCTRINE</span>
        </Reveal>
        <motion.h2
          style={{ y }}
          className="mt-8 max-w-4xl font-display text-3xl font-light leading-tight tracking-tight text-white/90 sm:text-4xl lg:text-5xl"
          data-testid="manifesto-lead"
        >
          Most consultants advise. We architect, engineer, and{" "}
          <span className="text-gradient font-medium">deliver the future</span> our clients only imagine.
        </motion.h2>

        <div className="mt-20 grid gap-px overflow-hidden rounded-3xl border border-white/10 md:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <div className="glass-hover h-full bg-white/[0.02] p-8 md:p-10">
                <span className="font-mono text-sm text-nexis-blue">{c.n}</span>
                <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-white">
                  {c.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-white/55">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
